export interface PointerMark {
  x: number;
  y: number;
  t: number;
}

/** A press and release that barely moved: a tap, not a drag (holding still still counts). */
export const isTap = (down: PointerMark, up: PointerMark) =>
  Math.hypot(up.x - down.x, up.y - down.y) <= 8;
